import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { setAdsModalDisplay, } from '../../actions/adsModal';
import Modal from 'react-modal';
import SliderCard from '../Cards/SliderCard';
import close from '../../images/icons/closedetail.png';



const AdsModal = () => {
  const dispatch = useDispatch();
  const { adsModalDisplay, currentAdsListing, } = useSelector(state => state.adsModal);
  const { selectedListing } = useSelector(state => state.filterSearch);
  const detailsClose = () => dispatch(setAdsModalDisplay(undefined));
  return (
    <Modal isOpen={adsModalDisplay}
      onRequestClose={detailsClose}
      ariaHideApp={false}
      contentLabel="lifecarefront.com"
      closeTimeoutMS={400}
      className='filter-search-group-modal'>
        <div className='close-detail-div'>
          <img onClick={() => {
            dispatch(setAdsModalDisplay(undefined));
          }} src={close} className='closedetail' alt='lifecarefront.com' />
        </div>
        <SliderCard 
          imgURL = {currentAdsListing.imageURL}
          imgURL1 = {currentAdsListing.imgUrl1}
          imgURL2 = {currentAdsListing.imgUrl2}
          imgURL3 = {currentAdsListing.imgUrl3}
          imgURL4 = {currentAdsListing.imgUrl4}
          imgURL5 = {currentAdsListing.imgUrl5}
          imgURL6 = {currentAdsListing.imgUrl6}
          imgURL7 = {currentAdsListing.imgUrl7}
          imgURL8 = {currentAdsListing.imgUrl8}
          imgURL9 = {currentAdsListing.imgUrl9}
          imgURL10 = {currentAdsListing.imgUrl10}
          videoURL = {currentAdsListing.videourl}       
        />
        <div className='listing-description-modal-div'>
          <p className='listing-description-modal-p'>{`     ${currentAdsListing.productName}`}</p>
          <p className='listing-description-modal-p'>{`     ${currentAdsListing.locationImg} ${currentAdsListing.areaName}, ${currentAdsListing.city}, ${currentAdsListing.state}`}</p>
          <p className='listing-description-modal-p'>{`     ${currentAdsListing.priceImg} ${currentAdsListing.currency} ${currentAdsListing.price}`}</p>
          <p className='listing-description-modal-p'>{`${currentAdsListing.description}`}</p>
          <button onClick={() => {
            typeof(selectedListing.title) === "undefined" ?
            window.location.href = `https://wa.me/2347070019934?text=${`Service needed LifeCare`}` :
            window.location.href = `https://wa.me/2347070019934?text=${`Hello LifeCare Front, my last check:
            listing No: ${selectedListing.productRef}, Property-Type: ${selectedListing.title}, 
            Property-Location: ${selectedListing.areaName}, ${selectedListing.city}, ${selectedListing.state}`}`; 
          }} className='adsmodal-reachout'>Reach Out for Details</button>
        </div>
      </Modal>
  )
};


export default AdsModal;